module.exports = __webpack_public_path__ + "img/bf037a0924cb97e233ad824b1e67bea7.png";